import React from 'react'
import { camelCase, kebabCase } from 'lodash'

import {
  ShapeSection,
  IProps as IShapeSection,
} from 'marketing-site/src/mvp/library/elements/ShapeSection'
import { IShapeSectionMvp as IContentfulShapeSection } from 'marketing-site/@types/generated/contentful'

export const ContentfulShapeSection = (props: IContentfulShapeSection): React.ReactElement => (
  <ShapeSection {...transformShapeSection(props)} />
)

export const transformShapeSection = ({ fields }: IContentfulShapeSection): IShapeSection => {
  return {
    ...fields,
    shape: kebabCase(fields.shape) as IShapeSection['shape'],
    size: kebabCase(fields.size) as IShapeSection['size'],
    color: camelCase(fields.color) as IShapeSection['color'],
    direction: kebabCase(fields.direction) as IShapeSection['direction'],
    position: kebabCase(fields.position) as IShapeSection['position'],
  }
}
